import ReservationTrailerIcon from "../assets/Icon/ReservationTrailerIcon";
import ReservationTruckIcon from "../assets/Icon/ReservationTruckIcon";
import ReservationTruckTrailerIcon from "../assets/Icon/ReservationTruckTrailerIcon";

export const selectedIcon = (clusterType) => {
  switch (clusterType) {
    case "TRUCK":
      return <ReservationTruckIcon style={{ alignSelf: "center" }} />;

    case "TRAILER":
      return <ReservationTrailerIcon style={{ alignSelf: "center" }} />;

    case "TRUCK_AND_TRAILER":
      return <ReservationTruckTrailerIcon style={{ alignSelf: "center" }} />;

    default:
      return null;
  }
};
export default selectedIcon;

export const getDayReservationSuffix = (day) => {
  if (day >= 11 && day <= 13) {
    return "th";
  }

  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const GATE_PIN_STATUS = {
  ACTIVE: "A",
  IN_ACTIVE: "I",
};

export const KEYS = {
  PHONE: "phone",
  PHONE_NUMBER: "phoneNumber",
  COUNTRY_CODE: "countryCode",
};
